export const STATES = {
  '01': {
    full: 'Alabama',
    abbr: 'AL',
    xmin: -88.473227,
    xmax: -84.88908,
    ymin: 30.223334,
    ymax: 35.008028
  },
  '02': {
    full: 'Alaska',
    abbr: 'AK',
    xmin: -179.148909,
    xmax: -119.9795,
    ymin: 51.214183,
    ymax: 71.365162
  },
  '04': {
    full: 'Arizona',
    abbr: 'AZ',
    xmin: -114.81651,
    xmax: -109.045223,
    ymin: 31.332177,
    ymax: 37.00426
  },
  '05': {
    full: 'Arkansas',
    abbr: 'AR',
    xmin: -94.617919,
    xmax: -89.644395,
    ymin: 33.004106,
    ymax: 36.4996
  },
  '06': {
    full: 'California',
    abbr: 'CA',
    xmin: -124.409591,
    xmax: -114.131211,
    ymin: 32.534156,
    ymax: 42.009518
  },
  '08': {
    full: 'Colorado',
    abbr: 'CO',
    xmin: -109.060253,
    xmax: -102.041524,
    ymin: 36.992426,
    ymax: 41.003444
  },
  '09': {
    full: 'Connecticut',
    abbr: 'CT',
    xmin: -73.727775,
    xmax: -71.786994,
    ymin: 40.980144,
    ymax: 42.050587
  },
  '10': {
    full: 'Delaware',
    abbr: 'DE',
    xmin: -75.788658,
    xmax: -75.048939,
    ymin: 38.451013,
    ymax: 39.839007
  },
  '11': {
    full: 'District of Columbia',
    abbr: 'DC',
    xmin: -77.119759,
    xmax: -76.909395,
    ymin: 38.791645,
    ymax: 38.99511
  },
  '12': {
    full: 'Florida',
    abbr: 'FL',
    xmin: -87.634938,
    xmax: -80.031362,
    ymin: 24.523096,
    ymax: 31.000888
  },
  '13': {
    full: 'Georgia',
    abbr: 'GA',
    xmin: -85.605165,
    xmax: -80.839729,
    ymin: 30.357851,
    ymax: 35.000659
  },
  '15': {
    full: 'Hawaii',
    abbr: 'HI',
    xmin: -178.334698,
    xmax: -154.806773,
    ymin: 18.910361,
    ymax: 28.402123
  },
  '16': {
    full: 'Idaho',
    abbr: 'ID',
    xmin: -117.243027,
    xmax: -111.043564,
    ymin: 41.988057,
    ymax: 49.001146
  },
  '17': {
    full: 'Illinois',
    abbr: 'IL',
    xmin: -91.513079,
    xmax: -87.494756,
    ymin: 36.970298,
    ymax: 42.508481
  },
  '18': {
    full: 'Indiana',
    abbr: 'IN',
    xmin: -88.09776,
    xmax: -84.784579,
    ymin: 37.771742,
    ymax: 41.760592
  },
  '19': {
    full: 'Iowa',
    abbr: 'IA',
    xmin: -96.639704,
    xmax: -90.140061,
    ymin: 40.375501,
    ymax: 43.501196
  },
  '20': {
    full: 'Kansas',
    abbr: 'KS',
    xmin: -102.051744,
    xmax: -94.588413,
    ymin: 36.993016,
    ymax: 40.003162
  },
  '21': {
    full: 'Kentucky',
    abbr: 'KY',
    xmin: -89.571509,
    xmax: -81.964971,
    ymin: 36.497129,
    ymax: 39.147458
  },
  '22': {
    full: 'Louisiana',
    abbr: 'LA',
    xmin: -94.043147,
    xmax: -88.817017,
    ymin: 28.928609,
    ymax: 33.019457
  },
  '23': {
    full: 'Maine',
    abbr: 'ME',
    xmin: -71.083924,
    xmax: -66.949895,
    ymin: 42.977764,
    ymax: 47.459686
  },
  '24': {
    full: 'Maryland',
    abbr: 'MD',
    xmin: -79.487651,
    xmax: -75.048939,
    ymin: 37.911717,
    ymax: 39.723043
  },
  '25': {
    full: 'Massachusetts',
    abbr: 'MA',
    xmin: -73.508142,
    xmax: -69.928393,
    ymin: 41.237964,
    ymax: 42.886589
  },
  '26': {
    full: 'Michigan',
    abbr: 'MI',
    xmin: -90.418136,
    xmax: -82.413474,
    ymin: 41.696118,
    ymax: 48.2388
  },
  '27': {
    full: 'Minnesota',
    abbr: 'MN',
    xmin: -97.239209,
    xmax: -89.491739,
    ymin: 43.499356,
    ymax: 49.384358
  },
  '28': {
    full: 'Mississippi',
    abbr: 'MS',
    xmin: -91.655009,
    xmax: -88.097888,
    ymin: 30.173943,
    ymax: 34.996052
  },
  '29': {
    full: 'Missouri',
    abbr: 'MO',
    xmin: -95.774704,
    xmax: -89.098843,
    ymin: 35.995683,
    ymax: 40.61364
  },
  '30': {
    full: 'Montana',
    abbr: 'MT',
    xmin: -116.050003,
    xmax: -104.039138,
    ymin: 44.358221,
    ymax: 49.00139
  },
  '31': {
    full: 'Nebraska',
    abbr: 'NE',
    xmin: -104.053514,
    xmax: -95.30829,
    ymin: 39.999998,
    ymax: 43.001708
  },
  '32': {
    full: 'Nevada',
    abbr: 'NV',
    xmin: -120.005746,
    xmax: -114.039648,
    ymin: 35.001857,
    ymax: 42.002207
  },
  '33': {
    full: 'New Hampshire',
    abbr: 'NH',
    xmin: -72.557247,
    xmax: -70.610621,
    ymin: 42.69699,
    ymax: 45.305476
  },
  '34': {
    full: 'New Jersey',
    abbr: 'NJ',
    xmin: -75.559614,
    xmax: -73.893979,
    ymin: 38.928519,
    ymax: 41.357423
  },
  '35': {
    full: 'New Mexico',
    abbr: 'NM',
    xmin: -109.050173,
    xmax: -103.001964,
    ymin: 31.332301,
    ymax: 37.000232
  },
  '36': {
    full: 'New York',
    abbr: 'NY',
    xmin: -79.762152,
    xmax: -71.856214,
    ymin: 40.496103,
    ymax: 45.01585
  },
  '37': {
    full: 'North Carolina',
    abbr: 'NC',
    xmin: -84.321869,
    xmax: -75.460621,
    ymin: 33.842316,
    ymax: 36.588117
  },
  '38': {
    full: 'North Dakota',
    abbr: 'ND',
    xmin: -104.0489,
    xmax: -96.554507,
    ymin: 45.935054,
    ymax: 49.000574
  },
  '39': {
    full: 'Ohio',
    abbr: 'OH',
    xmin: -84.820159,
    xmax: -80.518693,
    ymin: 38.403202,
    ymax: 41.977523
  },
  '40': {
    full: 'Oklahoma',
    abbr: 'OK',
    xmin: -103.002565,
    xmax: -94.430662,
    ymin: 33.615833,
    ymax: 37.002206
  },
  '41': {
    full: 'Oregon',
    abbr: 'OR',
    xmin: -124.566244,
    xmax: -116.463504,
    ymin: 41.991794,
    ymax: 46.292035
  },
  '42': {
    full: 'Pennsylvania',
    abbr: 'PA',
    xmin: -80.519891,
    xmax: -74.689516,
    ymin: 39.7198,
    ymax: 42.26986
  },
  '44': {
    full: 'Rhode Island',
    abbr: 'RI',
    xmin: -71.862772,
    xmax: -71.12057,
    ymin: 41.146339,
    ymax: 42.018798
  },
  '45': {
    full: 'South Carolina',
    abbr: 'SC',
    xmin: -83.35391,
    xmax: -78.54203,
    ymin: 32.0346,
    ymax: 35.215402
  },
  '46': {
    full: 'South Dakota',
    abbr: 'SD',
    xmin: -104.057698,
    xmax: -96.436589,
    ymin: 42.479635,
    ymax: 45.94545
  },
  '47': {
    full: 'Tennessee',
    abbr: 'TN',
    xmin: -90.310298,
    xmax: -81.6469,
    ymin: 34.982972,
    ymax: 36.678118
  },
  '48': {
    full: 'Texas',
    abbr: 'TX',
    xmin: -106.645646,
    xmax: -93.508292,
    ymin: 25.837377,
    ymax: 36.500704
  },
  '49': {
    full: 'Utah',
    abbr: 'UT',
    xmin: -114.052962,
    xmax: -109.041058,
    ymin: 36.997968,
    ymax: 42.001567
  },
  '50': {
    full: 'Vermont',
    abbr: 'VT',
    xmin: -73.43774,
    xmax: -71.464555,
    ymin: 42.726853,
    ymax: 45.016659
  },
  '51': {
    full: 'Virginia',
    abbr: 'VA',
    xmin: -83.675395,
    xmax: -75.242266,
    ymin: 36.540738,
    ymax: 39.466012
  },
  '53': {
    full: 'Washington',
    abbr: 'WA',
    xmin: -124.763068,
    xmax: -116.915989,
    ymin: 45.543541,
    ymax: 49.002494
  },
  '54': {
    full: 'West Virginia',
    abbr: 'WV',
    xmin: -82.644739,
    xmax: -77.719519,
    ymin: 37.201483,
    ymax: 40.638801
  },
  '55': {
    full: 'Wisconsin',
    abbr: 'WI',
    xmin: -92.888114,
    xmax: -86.805415,
    ymin: 42.491983,
    ymax: 47.080621
  },
  '56': {
    full: 'Wyoming',
    abbr: 'WY',
    xmin: -111.056888,
    xmax: -104.05216,
    ymin: 40.994746,
    ymax: 45.005904
  },
  '72': {
    full: 'Puerto Rico',
    abbr: 'PR',
    xmin: -67.2424275377,
    xmax: -65.5910037909,
    ymin: 17.946553453,
    ymax: 18.5206011011
  }
}
